import React from "react";
import Datatable from "../components/datatable/Datatable";

const Tourreservations = () => {
  return (
    <>
      <div className="flex flex-row col-span-2 lg:px-32 px-8 pt-7 pb-2 justify-between md:items-center ">
        <div className="text-3xl font-bold">Tour Package Reservations</div>
      </div>
      <Datatable />
    </>
  );
};

export default Tourreservations;
